import React, { useContext } from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/Seo"
import { I18nextContext } from "gatsby-plugin-react-i18next"
import { GatsbyImage } from "gatsby-plugin-image"
import PortableText from "../components/PortableText"
import Contact from "../components/ContactButton"
import YouTube from "react-youtube"
import getVideoId from "get-video-id"

const AboutLaura = ({ data }) => {
  const { language } = useContext(I18nextContext)
  const { blockOne, title, testimonials, youtubelink } = data.sanityAbout
  const opts = {
    height: "390",
    width: "640",
    playerVars: {
      autoplay: 0,
    },
  }

  return (
    <Layout>
      <Seo lang={language} title={title[language]} />
      <div className="max-w-screen-xl mx-auto">
        <div className="grid3">
          <div className="col-span-3 sm:col-span-1">
            <figure>
              <GatsbyImage
                image={
                  blockOne.thumbnail.asset?.localFile.childImageSharp
                    .gatsbyImageData
                }
                className="rounded"
                alt={blockOne.thumbnail.attribution || "Minä voin"}
              />
              {blockOne.thumbnail.caption !== null && (
                <figcaption className="text-gray-900 pt-2">
                  {blockOne.thumbnail.caption[language]}
                </figcaption>
              )}
            </figure>
            <div className="relative pt-40">
              <YouTube
                videoId={getVideoId(youtubelink.url).id}
                opts={opts}
                className="absolute w-full h-full top-0 left-0 rounded"
              />
            </div>
          </div>
          <div className="col-span-3 sm:col-span-2">
            <h1>{blockOne.header[language]}</h1>
            <hr />
            <PortableText textData={blockOne._rawBody[language]} />
            <Contact />
          </div>
        </div>
      </div>
      <div className="max-w-screen-2xl mx-auto bg-gray-50">
        <div className="max-w-screen-xl mx-auto bg-gray-50">
          <div className="p-10 grid grid-cols-4 gap-5 lg:gap-10">
            <div className="col-span-full text-center">
              <h1 className="flex items-center justify-center header text-2xl lg:text-3xl mb-0">
                {testimonials.header[language]}
              </h1>
              <h5 className="font-body leading-6 py-3 mb-0">
                {testimonials.headerTwo[language]}
              </h5>
            </div>
            {testimonials.testimonials.map(testimonial => {
              return (
                <div
                  key={testimonial._id}
                  className="last:col-span-4 col-span-4 sm:col-span-4 md:col-span-4 lg:col-span-2 p-10 border-l-2 border-red-600 transition-all duration-150 bg-white rounded shadow hover:shadow-lg"
                >
                  <p>"{testimonial.text[language]}"</p>
                  <small className="italic font-body uppercase">
                    &#8212;&nbsp;{testimonial.name[language]}
                  </small>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </Layout>
  )
}
export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    sanityAbout {
      title {
        en
        fi
      }
      blockOne {
        _rawBody(resolveReferences: { maxDepth: 10 })
        header {
          en
          fi
        }
        thumbnail {
          asset {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          attribution
          caption {
            en
            fi
          }
        }
      }
      testimonials {
        header {
          en
          fi
        }
        headerTwo {
          en
          fi
        }
        testimonials {
          _id
          name {
            en
            fi
          }
          text {
            en
            fi
          }
        }
      }
      youtubelink: YouTube {
        url
      }
    }
  }
`
export default AboutLaura
